<template>
  <div class="sessions-attributes" v-if="selectedSession.gateway_session_id">
    <stop-chat :selected-session="selectedSession" />
    <div class="sessions-attributes--wrapper">
      <v-expansion-panel v-model="panel">
        <v-expansion-panel-content :key="1">
          <template v-slot:header>
            <h3>Static Attributes</h3>
          </template>
          <v-card>
            <v-card-text>
              <v-layout
                v-for="(value, key) in sessionsList.staticAttributes"
                :key="key"
                class="mb-2"
                wrap
                row
              >
                <v-flex xs12 class="attribute-key"
                  ><p class="mb-0 text-capitalize">
                    {{ key.replace(/_/g, " ") }}
                  </p></v-flex
                >
                <v-flex xs12 class="word-break-all">{{ value }}</v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <v-expansion-panel-content :key="2">
          <template v-slot:header>
            <h3>Dynamic Attributes</h3>
          </template>
          <v-card>
            <v-card-text>
              <v-layout
                v-for="(value, key) in sessionsList.dynamicAttributes"
                :key="key"
                class="mb-2"
                wrap
                row
              >
                <v-flex xs12 class="attribute-key"
                  ><p class="mb-0 text-capitalize">
                    {{ key.replace(/_/g, " ") }}
                  </p></v-flex
                >
                <v-flex xs12 class="word-break-all">{{ value }}</v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <div class="mt-3 text-center">
        <download-chat />
      </div>
    </div>
  </div>
</template>

<script>
import downloadChat from "../singleSession/downloadChat";
import stopChat from "./stopChat";
export default {
  name: "attributesList",
  props: {
    selectedSession: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    stopChat,
    downloadChat,
  },
  data() {
    return {
      sessionsList: {},
      panel: [true, false],
    };
  },
  mounted() {},
  methods: {
    async getSessionsList() {
      const response = await this.$http_session_manager.get(
        `/sessions/attributes-classified/`,
        {
          params: {
            gateway_session_id: this.selectedSession.gateway_session_id,
            bot_id: this.$store.state.bot.botId,
          },
        },
      );

      this.sessionsList = JSON.parse(response.data);
    },
  },
  computed: {
    selectedSessionId() {
      return this.selectedSession._id;
    },
  },
  watch: {
    async selectedSessionId() {
      await this.getSessionsList();
    },
  },
};
</script>

<style lang="scss">
.sessions-attributes {
  h3 {
    padding: 0 15px;
    color: black;
  }
  .attribute-key {
    color: black;
    font-weight: bold;
    p {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  &--wrapper {
    height: calc(100vh - 180px);
    scroll-behavior: smooth;
    overflow-y: auto;
    overflow-x: hidden;
    &::-webkit-scrollbar {
      width: 0px;
      background: #ddd;
    }

    &::-webkit-scrollbar-track {
      //box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
    }
  }
  .v-expansion-panel .v-expansion-panel__container {
    border-bottom: 2px solid #eee !important;
    border-top: none !important;
    .v-card__text {
      padding-top: 5px;
    }
  }
}
</style>
